document.addEventListener("DOMContentLoaded", function () {

    // Home Video size
    // Swap out landscape and portrait videos.

    function updateVideoSource() {
        const video = document.getElementById("troxy-hero-video");
        const videoSource = document.getElementById("troxy-hero-video-source");
        const isAbove750px = window.matchMedia("(min-width: 750px)").matches;
        let mobVid = video.getAttribute('data-portrait');
        let desktopVid = video.getAttribute('data-landscape');
      
        if (mobVid === null) {
          mobVid = "";
        }
      
        if (desktopVid === null) {
          desktopVid = "";
        }
      
        if (isAbove750px && !video.classList.contains('above-750px')) {
          // Change the video source for screens 750px and above
          videoSource.src = desktopVid;
          video.classList.add('above-750px');
          video.classList.remove('below-750px');
          video.load();
        } else if (!isAbove750px && !video.classList.contains('below-750px')) {
          // Change the video source for screens below 750px
          videoSource.src = mobVid;
          video.classList.add('below-750px');
          video.classList.remove('above-750px');
          video.load();
        }
      }
      
      if (document.querySelector('#troxy-hero-video')) {
        // Call the function on page load
        updateVideoSource();
      
        // Add an event listener for screen resize
        window.addEventListener("resize", updateVideoSource);
      }
      
  


    // HOME - VIDEO HERO
    // Pause Button

    function troxyVideoHeroControls() {

        if (document.querySelector('#troxy-hero-video')) {
            const vid = document.querySelector('#troxy-hero-video');
            const btn = document.querySelector('#troxy-pause-video');
        
            // add a click event listener to the button
        btn.addEventListener('click', () => {
          // check if the video is currently paused
  
          console.log('clicked')
  
          if (vid.paused) {
            // if paused, play the video
            vid.play();
            // update button text to "Pause Video"
            btn.textContent = "Pause";
            btn.setAttribute("aria-pressed", "false");
          } else {
            // if playing, pause the video
            vid.pause();
            // update button text to "Play Video"
            btn.textContent = "Play";
            btn.setAttribute("aria-pressed", "true");
          }
          });
        }
    }
  
    if(document.querySelector('#troxy-pause-video')) {
      troxyVideoHeroControls();
    }
  


})